import React from "react";

export default function AdminTicketModal ({ isOpen, onClose, children }) {
    if (!isOpen) return null;

    return (
        <div
            onClick={onClose}
            className="fixed inset-0 flex items-center justify-center bg-black/50 z-50"
        >
            <div
                onClick={(e) => e.stopPropagation()}
                className="bg-white rounded-xl p-6 w-[500px] relative"
            >
                <button
                    onClick={onClose}
                    className="absolute top-2 right-3 text-gray-500 hover:text-red-500"
                >
                    ✕
                </button>

                {children}
            </div>
        </div>
    );
};


